<template>
  <div class="schema">
    <Button class="top-create--btn" type="primary" @click="showCreateModal">{{ $t('schema.createSchema') }}</Button>
    <Table :loading="loading" :columns="recordsCol" :data="records"></Table>
    <!-- create | edit | detail -->
    <Modal
      v-model="createModalVisible"
      class-name="schema-modal--create"
      :title="isEdit ? $t('schema.editSchema') : isDetail ? $t('schema.detailSchema') : $t('schema.addSchema')"
      :width="600"
      :mask-closable="false"
    >
      <Form v-if="createModalVisible" ref="createForm" :model="createForm" :rules="rules">
        <Row>
          <i-col span="24">
            <FormItem :label="$t('schema.schemaName')" prop="name">
              <i-input v-model="createForm.name" :disabled="isEdit || isDetail" size="large"></i-input>
            </FormItem>
          </i-col>
          <i-col span="24">
            <FormItem :label="$t('schema.schemaType')" prop="type">
              <Select v-model="createForm.type" size="large" @on-change="changeType">
                <Option
                  v-for="item in typesList"
                  :disabled="isDetail"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                >
                </Option>
              </Select>
            </FormItem>
          </i-col>
          <!-- sofile -->
          <i-col span="24">
            <FormItem prop="soFile" class="soFile">
              <template slot="label">
                <span :class="{ redStarLable: isCustomType }">{{ $t('schema.binaryFile') }}</span>
              </template>
              <a href="javascript:void(0);" class="label-link" @click="showUploadFileModal">
                {{ $t('upload.uploadFile') }}
              </a>
              <FileListAutoCompeleteSeletor
                ref="sofileListSelectRef"
                v-model="createForm.soFile"
                :prefix="'file://'"
                :disabled="isDetail"
                placeholder="file:///tmp/ekuiper/internal/schema/test/test2.so"
              />
            </FormItem>
          </i-col>

          <!-- schema content -->
          <i-col v-if="isProtobufType" span="24">
            <div class="redStar schema-content-label-wrap">
              <span class="schema-content-label" :class="{ redStarLable: isProtobufType }">
                {{ $t('schema.schemaContent') }}
              </span>
              <RadioGroup
                v-if="!isDetail"
                v-model="fileOrContent"
                type="button"
                size="small"
                class="label-link"
                @on-change="changeContentWay"
              >
                <Radio label="file">{{ $t('common.file') }}</Radio>
                <Radio label="text">{{ $t('common.text') }}</Radio>
              </RadioGroup>
            </div>
          </i-col>
          <!-- file -->
          <i-col v-if="(isProtobufType && fileOrContent === 'file') || isDetail" span="24">
            <FormItem :label="!isDetail ? '' : $t('common.file')" prop="file">
              <FileListAutoCompeleteSeletor
                ref="fileListSelectRef"
                v-model="createForm.file"
                :prefix="'file://'"
                placeholder="file:///tmp/ekuiper/internal/schema/test/test2.proto"
                :disabled="isDetail"
              />
            </FormItem>
          </i-col>
          <!-- content -->
          <i-col v-if="fileOrContent === 'text' || isDetail" span="24">
            <FormItem :label="!isDetail ? '' : $t('common.text')" prop="content" key="content">
              <i-input
                v-model="createForm.content"
                type="textarea"
                :rows="3"
                size="large"
                :disabled="isDetail"
                placeholder="message Book {required string title = 1; required int32 price = 2;}"
              ></i-input>
            </FormItem>
          </i-col>
        </Row>
      </Form>
      <div slot="footer" v-show="!isDetail">
        <Button type="text" @click="createModalVisible = false">{{ $t('common.cancel') }}</Button>
        <Button type="primary" @click="save">{{ $t('common.submit') }}</Button>
      </div>
    </Modal>

    <UploadFileModal
      :modalVisible.sync="uploadFileModalVisible"
      :isSupportCustom="false"
      :fileAccepts="'.so'"
      @reload="reloadFileList"
    />
  </div>
</template>

<script>
import nodeID from '@/mixins/nodeID'
import schema from '@/mixins/schema'
import { deleteSchema, createSchema, updateSchema, viewSchema } from '@/api/schema'
import FileListAutoCompeleteSeletor from '@/views/configuration/uploads/components/FileListAutoSelector.vue'
import UploadFileModal from '@/views/configuration/uploads/UploadFileModal.vue'
import UploadFile from '@/views/configuration/uploads/components/UploadFile.vue'

export default {
  name: 'Schema',

  mixins: [nodeID, schema],

  components: { FileListAutoCompeleteSeletor, UploadFileModal, UploadFile },

  data() {
    return {
      loading: false,
      isEdit: false,
      isDetail: false,
      createModalVisible: false,
      createForm: {
        type: 'protobuf',
      },
      typesList: [
        {
          value: 'protobuf',
          label: 'protobuf',
        },
        {
          value: 'custom',
          label: 'custom',
        },
      ],
      fileOrContent: 'file',
      records: [],
      recordsCol: [
        {
          title: this.$t('common.name'),
          key: 'name',
          render: (h, params) => {
            return (
              <div>
                <a
                  href="javascript:;"
                  onClick={() => {
                    this.showDetail(params.row, 'view')
                  }}
                >
                  {params.row.name}
                </a>
              </div>
            )
          },
        },
        {
          title: this.$t('common.type'),
          key: 'type',
          render: (h, params) => {
            return <div>{params.row.type}</div>
          },
        },
        {
          title: this.$t('common.operations'),
          key: 'action',
          width: 200,
          align: 'center',
          render: (h, params) => {
            return (
              <div>
                <a
                  style="margin-right: 10px;"
                  href="javascript:;"
                  onClick={() => {
                    this.showDetail(params.row, 'edit')
                  }}
                >
                  <Icon type="ios-create"></Icon>
                </a>
                <a href="javascript:;">
                  <Poptip
                    confirm={true}
                    transfer={true}
                    width={200}
                    title={this.$t('common.confirmDelete')}
                    placement="top"
                    type="error"
                    vOn:on-ok={() => {
                      this.remove(params.row, 'edit')
                    }}
                    vOn:on-cancel={() => {}}
                  >
                    <Icon type="md-trash"></Icon>
                  </Poptip>
                </a>
              </div>
            )
          },
        },
      ],
      uploadFileModalVisible: false,
    }
  },

  computed: {
    rules() {
      return {
        type: [{ required: true, message: this.$t('common.fillContent') }],
        name: [{ required: true, message: this.$t('common.fillContent') }],
        soFile: [{ required: !this.isDetail && this.isCustomType, message: this.$t('common.fillContent') }],
        file: [{ required: !this.isDetail && this.isProtobufType, message: this.$t('common.fillContent') }],
        content: [{ required: !this.isDetail && this.isProtobufType, message: this.$t('common.fillContent') }],
      }
    },
    isProtobufType() {
      return this.createForm.type === 'protobuf'
    },
    isCustomType() {
      return this.createForm.type === 'custom'
    },
  },

  watch: {
    createModalVisible(val) {
      if (!val) {
        this.$refs.createForm.resetFields()
        this.isEdit = false
        this.isDetail = false
      }
    },
  },

  created() {
    this.getSchemas()
  },

  methods: {
    getSchemas() {
      this.loading = true
      this.getSchemaList(this.nodeID)
        .then((res) => {
          this.loading = false
          this.records = res || []
        })
        .catch((error) => {
          this.loading = false
          this.records = []
          console.log('error', error)
        })
    },
    showCreateModal() {
      this.createModalVisible = true
    },
    showDetail({ name, type }, oper) {
      this.createModalVisible = true
      this.isEdit = oper === 'edit'
      this.isDetail = oper === 'view'
      viewSchema(this.nodeID, name, type)
        .then((res) => {
          this.createForm = res.data
        })
        .catch(() => {})
    },
    remove({ name, type }) {
      deleteSchema(this.nodeID, name, type)
        .then(() => {
          this.$Message.success(this.$t('common.deleteSuccess'))
          this.getSchemas()
        })
        .catch(() => {})
    },

    changeType() {
      this.createForm.file = ''
      this.createForm.content = ''
      this.createForm.soFile = ''
    },

    changeContentWay() {
      const validateFields = this.$refs.createForm.fields || []
      validateFields.forEach((item) => {
        const { prop } = item
        if (prop === 'content' || prop === 'file') {
          item.validateState = ''
        }
      })
    },

    // upload file
    showUploadFileModal() {
      this.uploadFileModalVisible = true
    },
    reloadFileList() {
      this.$refs.sofileListSelectRef.getFileList()
      this.$refs.fileListSelectRef.getFileList()
    },

    save() {
      this.$refs.createForm.validate((valid) => {
        if (valid) {
          const { type, ...data } = this.createForm
          const { file, content, ...items } = data
          const params = this.fileOrContent === 'file' ? { file, ...items } : { content, ...items }
          if (this.isEdit) {
            updateSchema(this.nodeID, type, data.name, params)
              .then(() => {
                this.$Message.success(this.$t('common.editSuccess'))
                this.getSchemas()
                this.createModalVisible = false
              })
              .catch(() => {})
          } else {
            createSchema(this.nodeID, type, params)
              .then(() => {
                this.$Message.success(this.$t('common.addSuccess'))
                this.getSchemas()
                this.createModalVisible = false
              })
              .catch(() => {})
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.label-link {
  float: right;
  color: var(--color-text-normal);
}
.schema-content-label-wrap {
  margin-bottom: 14px;
}

.redStarLable::before {
  content: '*';
  display: inline-block;
  line-height: 1;
  font-size: 18px;
  color: #de4563;
  position: relative;
  top: 2px;
}
</style>
